import { useState, useEffect, useRef } from 'react';
import { useFormState, useForm } from 'react-final-form';

import { findInvalid, calculateProgress } from '.';

/** Хук вычисляет значение заполненности прогресс-бара и выбирает нужный плейсхолдер для текста над/под линией прогресс-бара */
export const useProgress = (initValue?: number) => {
    const { active = '', errors } = useFormState({
        subscription: { active: true, errors: true },
    });
    const form = useForm();
    const fieldData = form.getFieldState(active)?.data ?? {};

    // При наличии поля и ошибок в поле и настроек для прогресс-бара - проставлять поле
    const newField =
        errors[active] && fieldData.progressBarValue ? active : findInvalid(errors, form);

    const data = form.getFieldState(newField)?.data ?? {};
    const fieldProgress = {
        placeholder: data.progressBarText || data.placeholder,
        progressBarValue: data.progressBarValue,
    };

    const value = calculateProgress(form, initValue);

    return { fieldProgress, value };
};

/** Хук проставляет стики только когда блок с прогресс-баром находится в области видимости */
export const useSticky = (sticky?: boolean) => {
    const [isSticky, setSticky] = useState(false);
    const progressRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (!sticky) return;

        const observer = new IntersectionObserver(
            ([{ intersectionRatio }]) =>
                intersectionRatio < 1 ? setSticky(true) : setSticky(false),
            {
                threshold: [1],
            }
        );

        if (progressRef.current) {
            observer.observe(progressRef.current);
        }

        return () => {
            observer.disconnect();
        };
    }, [sticky]);

    return { isSticky, progressRef };
};
